import { Directive, HostBinding, HostListener, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[expandableTableDetailRow]'
})
export class ExpandableTableDetailRowDirective {
    private row: any;
    private tRef!: TemplateRef<any>;
    private opened!: boolean;

    @HostBinding('class.expanded')
    get expended(): boolean {
        return this.opened;
    }

    /**
     * If false, the row is not permitted to collapse.
     */
    @Input()
    public canCollapse = true;

    /**
     * A unique id for the row this directive is attached to,
     * used as a way to get a reference to a specific directive
     * amongst all of the table rows. Admittedly kind of hacky.
     */
    @Input()
    public expandableRowId?: any;

    @Input()
    set expandableTableDetailRow(value: any) {
        if (value !== this.row) {
            this.row = value;
            // this.render();
        }
    }

    @Input('detailRowTpl')
    set template(value: TemplateRef<any>) {
        if (value !== this.tRef) {
            this.tRef = value;
            // this.render();
        }
    }

    constructor(public vcRef: ViewContainerRef) { }

    @HostListener('click')
    onClick(): void {
        this.toggle();
    }

    toggle(): void {
        if (this.opened) {
            if (this.canCollapse) {
                this.vcRef.clear();
            }
        } else {
            this.render();
        }
        this.opened = this.vcRef.length > 0;
    }

    /**
     * Public method to expand the row.
     */
    public expand(): void {
        if (this.opened) {
            return;
        }

        this.toggle();
    }

    /**
     * Public method to collapse the row.
     */
    public collapse(): void {
        if (!this.opened) {
            return;
        }

        this.toggle();
    }

    private render(): void {
        this.vcRef.clear();
        if (this.tRef && this.row) {
            this.vcRef.createEmbeddedView(this.tRef, { $implicit: this.row });
        }
    }
}
